module.exports = __webpack_public_path__ + "img/Mimulus_guttatus.ac828a8b.jpg";